import { TblCol, TblFltOption } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblViewSpec } from '../../../../core/table/table-view.types';
import { MFR_RESTRICTIONS_STATUS_ACTIVE, MFR_RESTRICTIONS_STATUS_INACTIVE } from '../../mfr_restrictions_const';
import FormattedDateRenderer from '../../../../core/table/renderers/FormattedDateRenderer';
import MultipleItemsRenderer from '../../../../core/table/renderers/MultipleItemsRenderer';
import ExemptedStatesRenderer from './ExemptedStatesRenderer';

export type ColKey =
    | ''
    | 'CeRestrictTypes'
    | 'ExemptStates'
    | 'Name'
    | 'LabelerId'
    | 'MfrName'
    | 'ModifiedBy'
    | 'ModifiedDate'
    | 'ParentCo'
    | 'Status';

function statusOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: MFR_RESTRICTIONS_STATUS_ACTIVE, val: MFR_RESTRICTIONS_STATUS_ACTIVE },
        { lbl: MFR_RESTRICTIONS_STATUS_INACTIVE, val: MFR_RESTRICTIONS_STATUS_INACTIVE },
    ];
}

// column spec (map the keys to the column types)
export function mfrRestrictionsListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'MfrName', { title: 'Name' });
    tblSpecAddColumn<ColKey>(map, 'LabelerId', { width: '140px', title: 'Labeler ID' });
    tblSpecAddColumn<ColKey>(map, 'ParentCo', { title: 'Parent Company' });
    tblSpecAddColumn<ColKey>(
        map,
        'CeRestrictTypes',
        { width: '140px', type: 'MULTITEXT', title: 'Facility Types' },
        MultipleItemsRenderer,
    );
    tblSpecAddColumn<ColKey>(
        map,
        'ExemptStates',
        { type: 'MULTITEXT', title: 'Exempted States', width: '120px' },
        ExemptedStatesRenderer,
    );
    tblSpecAddColumn<ColKey>(map, 'Status', { type: 'DROPTEXT', fltOptions: statusOptions() });
    tblSpecAddColumn<ColKey>(
        map,
        'ModifiedDate',
        { width: '120px', title: 'Last Modified', type: 'DATE' },
        FormattedDateRenderer,
    );
    tblSpecAddColumn<ColKey>(map, 'ModifiedBy', { title: 'Modified By' });
    return map;
}

// default view
export function mfrRestrictionsListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Manufacturer',
                cols: ['MfrName', 'LabelerId', 'ParentCo'],
            },
            {
                title: 'Restrictions',
                cols: ['CeRestrictTypes', 'ExemptStates'],
            },
            {
                title: 'Usage',
                cols: ['Status', 'ModifiedDate', 'ModifiedBy'],
            },
        ],
        sortby: 'MfrName',
        filterby: [{ key: 'Status', val: 'ACTIVE' }],
    };
}
